function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDeletedRoom = function SvgDeletedRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 0c11 0 20 9 20 20s-9 20-20 20S0 31 0 20 9 0 20 0z",
    style: {
      fill: "#8b9c8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9 13c0-1.7 1.3-3 3-3h2c1.7 0 3 1.3 3 3H27c.2 0 .5.2.5.4l.3 2c.1.3-.2.6-.5.6H12.5c-.3 0-.5-.3-.5-.6l.3-2c0-.2.2-.4.5-.4h3.1zm2 0c0-.6.4-1 1-1h2c.6 0 1 .4 1 1h-4z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 18.5.9 10c0 .3.2.5.5.5h11.1c.3 0 .5-.2.5-.5l.9-10c0-.3-.2-.5-.5-.5H13.5c-.3 0-.6.3-.5.5z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgDeletedRoom;